import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { AuthenticationStore, useAuthentication } from '@freelancelabs/components';

import ProtectedRoute from '../app/components/ProtectedRoute';
import PrivateLayout from '../app/content/PrivateLayout';
import { PrivateRoutes, PublicRoutes } from '../constants';
import ActivationPage from './Activation';
import CguPage from './Cgu';
import EmailSentPage from './EmailSent';
import LoginPage from './Login';
import LoginCheckPage from './LoginCheck';
import LoginPasswordLessPage from './LoginPasswordLess';
import ResetPasswordPage from './ResetPassword';
import UpdatePasswordPage from './UpdatePassword';
import AccountPage from './private/Account';
import RedirectMiddlewarePage from './private/RedirectMiddleware';

const Pages = () => {
    const { hasSession } = useAuthentication() as AuthenticationStore;
    return (
        <BrowserRouter>
            <Routes>
                <Route path={PublicRoutes.CGU} element={<CguPage />} />
                {/* Reachable with or without a session on purpose: a shared Cognito identity
                    may be logged in yet still have a pending invitation here. */}
                <Route path={PublicRoutes.ACTIVATION} element={<ActivationPage />} />
                <Route
                    element={
                        <ProtectedRoute isAllowed={!hasSession} redirectPath={PrivateRoutes.REDIRECT_MIDDLEWARE} />
                    }
                >
                    <Route path={PublicRoutes.LOGIN} element={<LoginPage />} />
                    <Route path={PublicRoutes.LOGIN_PASSWORD_LESS} element={<LoginPasswordLessPage />} />
                    <Route path={PublicRoutes.LOGIN_CHECK} element={<LoginCheckPage />} />
                    <Route path={PublicRoutes.RESET_PASSWORD} element={<ResetPasswordPage />} />
                    <Route path={PublicRoutes.UPDATE_PASSWORD} element={<UpdatePasswordPage />} />
                    <Route path={PublicRoutes.EMAIL_SENT} element={<EmailSentPage />} />
                </Route>
                <Route element={<ProtectedRoute isAllowed={hasSession} redirectPath={PublicRoutes.LOGIN} />}>
                    {/* RedirectMiddleware stays outside the shell: it is the CGU/MFA barrier,
                        which the menu must not let you step around. */}
                    <Route path={PrivateRoutes.HOMEPAGE} element={<RedirectMiddlewarePage />} />
                    <Route path={PrivateRoutes.REDIRECT_MIDDLEWARE} element={<RedirectMiddlewarePage />} />
                    <Route element={<PrivateLayout />}>
                        <Route path={PrivateRoutes.ACCOUNT} element={<AccountPage />} />
                        <Route
                            path={PrivateRoutes.SECURITY}
                            element={<Navigate to={PrivateRoutes.ACCOUNT} replace />}
                        />
                    </Route>
                </Route>
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </BrowserRouter>
    );
};

export default Pages;
